import React, { useRef } from "react";
import { Box, Typography, Container, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ProductCard from "../ProductCard/ProductCard";

const rubikfont = { fontFamily: "Rubik, sans-serif" };

// Layout 2: "Carousel". A tinted band with one swipeable row of products and arrow buttons.
const Layout2 = ({ data }) => {
    const products = (data?.product_id || []).slice(0, 12);
    const navigate = useNavigate();
    const rail = useRef(null);
    const viewAll = () => navigate(`/search?layoutId=${data._id}&title=${encodeURIComponent(data.title)}`);
    const slide = (dir) => rail.current?.scrollBy({ left: dir * rail.current.clientWidth * 0.8, behavior: "smooth" });

    return (
        <Box sx={{ py: { xs: 2.5, md: 4 }, my: { xs: 1, md: 2 }, background: "linear-gradient(180deg, #fbf7ef 0%, #f6efe0 100%)" }}>
            <Container maxWidth="xl">
                <Box sx={{ mb: 2.5, display: "flex", justifyContent: "space-between", alignItems: "flex-end", gap: 2 }}>
                    <Box>
                        <Typography sx={{ fontSize: "11px", fontWeight: 600, letterSpacing: "3px", color: "#C8A054", textTransform: "uppercase", mb: 0.5, ...rubikfont }}>
                            {data?.subtitle || "Exclusive Collection"}
                        </Typography>
                        <Typography sx={{ fontSize: { xs: "24px", sm: "30px" }, fontWeight: 800, color: "#111", fontFamily: "'Playfair Display', serif", lineHeight: 1.1 }}>
                            {data?.title}
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <Typography onClick={viewAll} sx={{ fontSize: "12px", fontWeight: 600, color: "#111", cursor: "pointer", letterSpacing: "1.5px", textTransform: "uppercase", "&:hover": { color: "#C8A054" }, ...rubikfont }}>
                            View all
                        </Typography>
                        <Box sx={{ display: { xs: "none", sm: "flex" }, gap: 1 }}>
                            <IconButton aria-label="previous" onClick={() => slide(-1)} sx={{ width: 36, height: 36, bgcolor: "#fff", border: "1px solid #e8dcc2", "&:hover": { bgcolor: "#C8A054", color: "#fff" } }}>
                                <ArrowBackIosNewIcon sx={{ fontSize: 14 }} />
                            </IconButton>
                            <IconButton aria-label="next" onClick={() => slide(1)} sx={{ width: 36, height: 36, bgcolor: "#fff", border: "1px solid #e8dcc2", "&:hover": { bgcolor: "#C8A054", color: "#fff" } }}>
                                <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
                            </IconButton>
                        </Box>
                    </Box>
                </Box>

                <Box
                    ref={rail}
                    sx={{
                        display: "flex",
                        gap: { xs: 1.25, md: 2 },
                        overflowX: "auto",
                        scrollSnapType: "x mandatory",
                        pt: 1.5,
                        pb: 1.5,
                        scrollbarWidth: "none",
                        "&::-webkit-scrollbar": { display: "none" },
                    }}
                >
                    {products.map((product) => (
                        <Box key={product._id} sx={{ flex: "0 0 auto", width: { xs: 156, sm: 190, md: 215, lg: 225 }, scrollSnapAlign: "start" }}>
                            <ProductCard product={product} />
                        </Box>
                    ))}
                </Box>
            </Container>
        </Box>
    );
};

export default Layout2;
